import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwapAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.85223 19.6817V6.74173L3.79852 8.76723C3.3646 9.19519 2.66017 9.19519 2.22625 8.76723C1.79264 8.33935 1.79269 7.64543 2.22625 7.21752L6.17743 3.32062L6.26141 3.24549C6.69775 2.89449 7.34191 2.9196 7.74872 3.32062L11.6989 7.21752C12.1328 7.64548 12.1328 8.33928 11.6989 8.76723C11.265 9.19498 10.5615 9.19512 10.1276 8.76723L8.07391 6.74173V19.6817C8.07377 20.2868 7.57614 20.7777 6.96258 20.7777C6.34922 20.7775 5.85237 20.2866 5.85223 19.6817ZM15.7282 4.09595C15.7282 3.49074 16.2259 2.99989 16.8395 2.99989C17.4532 2.99989 17.9509 3.49073 17.9509 4.09595V17.0349L20.0046 15.0104C20.4385 14.5824 21.1419 14.5824 21.5759 15.0104C22.0097 15.4383 22.0097 16.1322 21.5759 16.5601L17.6257 20.456C17.4173 20.6615 17.1342 20.7777 16.8395 20.7777C16.5449 20.7777 16.2618 20.6615 16.0534 20.456L12.1032 16.5601C11.6693 16.1322 11.6694 15.4383 12.1032 15.0104C12.5371 14.5824 13.2406 14.5824 13.6745 15.0104L15.7282 17.0349V4.09595Z",
		fill: "currentColor"
	})
});
export default SvgSwapAlt;
